import { z } from 'zod';
import { PropertyType } from '../types/property.types.js';
export const updatePropertyInput = z.object({
    name: z.string().min(1).trim().optional(),
    type: z.enum([
        PropertyType.SmallText,
        PropertyType.LongText,
        PropertyType.SingleSelect,
        PropertyType.MultiSelect,
        PropertyType.Number
    ]).optional(),
    options: z.array(z.string().trim().min(1)).optional()
});

//# sourceMappingURL=update-property.input.js.map